import { Planzone, Identifiable, CalendarHolidays } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveCalendarHolidays(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    calendarHolidays: CalendarHolidays,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarHolidays>>({
        endpoint: "/calendarHolidayses/create",
        method: HttpMethods.POST,
        data: {
          planzone: planzone,
          ...calendarHolidays,
        },
      })
      .then((calendarHolidays) => calendarHolidays);
}

export { saveCalendarHolidays };
